module.exports = __webpack_public_path__ + "img/lainaamo@2x.bac77f8.png";